module.exports = " <div> <header class=header> <img class=logo v-if=showLogo src=" + require("./assets/img/logo.png") + " /> <span class=back @click=back v-if=showBack>返回</span> <h1>{{$route.title}}</h1> <div class=close @click=clickMenu v-if=showMenu> <span class=close-icon v-bind:class=\"{'open':menu}\"></span> </div> </header> <div class=container> <router-view class=view v-ref:pageview keep-alive></router-view> </div> <menulist :is-show=menu></menulist> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/.1.2.3@vue-html-loader!./~/.8.5.4@vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 23
// module chunks = 2